// extracted by mini-css-extract-plugin
module.exports = {"AuthAvatar":"AuthAvatar_AuthAvatar__1qsy_","User":"AuthAvatar_User__3hZ8y","Admin":"AuthAvatar_Admin__3wLmi","Popover":"AuthAvatar_Popover__JmH5K"};